export default __webpack_public_path__ + "static/media/iconBurger.88af6c7d.svg";